import { ShopifyCart } from "./shopify-types";

export const CART_TOKEN_COOKIE_NAME = "cart";

export interface IPDPInfo {
	productId: string
	variantId: string
	quantity: number
}

export function getPdpInfo(): IPDPInfo {
	// favor quick add modal ("Choose option") first
	const form = document.querySelector<HTMLFormElement>("quick-add-modal[open] form[data-type=add-to-cart-form]") ??
		document.querySelector<HTMLFormElement>("form[data-type=add-to-cart-form]");
	if (form === null) {
		throw new Error("PDP Info form not found");
	}
	const formData = new FormData(form);

	return {
		productId: <string>formData.get("product-id"),
		variantId: <string>formData.get("id"),
		quantity: Number(formData.get('quantity') ?? 1)
	};
}

export function debounce<T extends (...args: any[]) => void>(
	func: T,
	delay: number
) {
	let timeout: ReturnType<typeof setTimeout>;
	return (...args: Parameters<T>) => {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			func(...args);
		}, delay);
	};
}

export async function clearCart() {
	// Set cart cookie to expired to clear it and get a new cart
	if (window.cookieStore) {
		await window.cookieStore.delete(CART_TOKEN_COOKIE_NAME);
	} else {
		document.cookie = `${CART_TOKEN_COOKIE_NAME}=; path=/; expires=${new Date(0).toUTCString()}`
	}
}

export async function getCartToken(): Promise<string> {
	// Try to get the token from browser cookies
	const encodedToken = window.cookieStore ?
		(await window.cookieStore.get(CART_TOKEN_COOKIE_NAME))?.value
		:
		document.cookie
			.split("; ")
			.find((row) => row.startsWith(`${CART_TOKEN_COOKIE_NAME}=`))
			?.split("=")[1];
	if (encodedToken) {
		return decodeURIComponent(encodedToken);
	}

	// Fallback to slow method via Ajax API
	const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
	if (!cartResponse.ok) {
		throw new Error(`Error fetching Shopify cart: ${await cartResponse.text()}`);
	}
	const cart: ShopifyCart = await cartResponse.json();
	return cart.token;
}

